import gql from 'graphql-tag'
import { COMPANY_RECRUITER_FRAGMENT } from '@/components/Contacts/CompanyRecruiter/queries/CompanyRecruiters'

// Mutation used to invite an existing recruiter agency
export const InviteCompanyRecruiterMutation = gql`
  mutation ($input: InviteCompanyRecruiterInput!) {
    inviteCompanyRecruiter(input: $input) {
      ...CompanyRecruiterFragment
    }
  }
  ${COMPANY_RECRUITER_FRAGMENT}
`
